import {
  Box,
  Layers,
  LayoutDashboard,
  LogOut,
  Monitor,
  Moon,
  Package,
  RefreshCw,
  Settings,
  ShoppingCart,
  Sun,
  Users,
} from 'lucide-react';
import type { StaticAction } from './types';

export const STATIC_ACTIONS: StaticAction[] = [
  // Navigation
  {
    category: 'navigation',
    icon: LayoutDashboard,
    id: 'nav-dashboard',
    keywords: ['dashboard', 'home', 'overview', 'stats', 'analytics'],
    label: 'Go to Dashboard',
    url: '/dashboard',
  },
  {
    category: 'navigation',
    icon: Package,
    id: 'nav-products',
    keywords: ['products', 'items', 'plants', 'catalog'],
    label: 'Go to Products',
    url: '/products',
  },
  {
    category: 'navigation',
    icon: Layers,
    id: 'nav-variants',
    keywords: ['variants', 'sku', 'sizes', 'pots', 'bulk edit'],
    label: 'Go to Variants',
    url: '/variants',
  },
  {
    category: 'navigation',
    icon: Box,
    id: 'nav-inventory',
    keywords: ['inventory', 'stock', 'quantity', 'levels', 'available'],
    label: 'Go to Inventory',
    url: '/inventory',
  },
  {
    category: 'navigation',
    icon: ShoppingCart,
    id: 'nav-orders',
    keywords: ['orders', 'sales', 'purchases', 'fulfillment'],
    label: 'Go to Orders',
    url: '/orders',
  },
  {
    category: 'navigation',
    icon: Users,
    id: 'nav-customers',
    keywords: ['customers', 'buyers', 'clients', 'contacts'],
    label: 'Go to Customers',
    url: '/customers',
  },
  {
    category: 'navigation',
    icon: RefreshCw,
    id: 'nav-sync-history',
    keywords: ['sync', 'history', 'shopify', 'logs', 'imports'],
    label: 'Go to Sync History',
    url: '/sync-history',
  },
  {
    category: 'navigation',
    icon: Settings,
    id: 'nav-settings',
    keywords: [
      'settings',
      'configuration',
      'shopify',
      'connection',
      'preferences',
    ],
    label: 'Go to Settings',
    url: '/settings',
  },

  // Quick Actions
  {
    category: 'action',
    icon: RefreshCw,
    id: 'action-sync-shopify',
    keywords: ['sync', 'shopify', 'refresh', 'import', 'update', 'pull'],
    label: 'Sync with Shopify',
    action: 'trigger-sync',
  },

  // Theme
  {
    category: 'theme',
    icon: Sun,
    id: 'theme-light',
    keywords: ['light mode', 'light theme', 'bright', 'day'],
    label: 'Switch to Light Mode',
    action: 'theme-light',
  },
  {
    category: 'theme',
    icon: Moon,
    id: 'theme-dark',
    keywords: ['dark mode', 'dark theme', 'night'],
    label: 'Switch to Dark Mode',
    action: 'theme-dark',
  },
  {
    category: 'theme',
    icon: Monitor,
    id: 'theme-system',
    keywords: ['system theme', 'auto theme', 'default theme', 'os theme'],
    label: 'Use System Theme',
    action: 'theme-system',
  },

  // Utility
  {
    category: 'utility',
    icon: LogOut,
    id: 'logout',
    keywords: ['logout', 'sign out', 'exit', 'leave'],
    label: 'Sign Out',
    action: 'logout',
  },
];
